var loadRemoteResource = require('../reader/load-remote-resource');

function fetchFrom(callback) {
  return callback || loadRemoteResource;
}

module.exports = fetchFrom;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/options/fetch.js
// module id = 2439
// module chunks = 9